import {Component} from '@angular/core';
import {pluck, Subject, takeUntil} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {CommonService} from "../../../../shared/services/common.service";
import {
  profile,
  selectedUserProfile
} from 'src/app/modules/shared/core/shared.selectors';
import {roles} from 'src/app/modules/shared/constants/common.constants';

@Component({
  selector: 'app-behaviour-tracker-wrapper',
  templateUrl: './behavior-tracker-wrapper.component.html',
  styleUrls: ['./behavior-tracker-wrapper.component.css']
})
export class BehaviorTrackerWrapperComponent {
  selectedWeekNumber = -1;
  showDisclaimerBlock: boolean=false
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {
    this.commonService.onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        const { queryParams } = this.route.snapshot;

        if (!queryParams['weekNumber']) {
          this.router.navigate([], {
            queryParams: {
              weekNumber: -1
            }
          })
        }

        this.selectedWeekNumber = queryParams['weekNumber'];
      });

    this.store.select(profile)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((profileData: any) => {
      if (profileData && profileData.role === roles.adult && !this.route.snapshot.paramMap.get('memberId')) {
        const filteredData = profileData.participants.filter(participant=>!(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))
        if(filteredData.length === 0){
          this.showDisclaimerBlock = true
        }
      }
      if (!this.route.snapshot.paramMap.get('memberId')) {
        if (profileData.role === roles.participant && !profileData['groupId']) {
          this.showDisclaimerBlock = true
          return;
        }
      }
    })

    this.store.select(selectedUserProfile)
      .pipe(
        takeUntil(this.onDestroy),
        pluck('profile')
      ).
    subscribe((profileData: any) => {
      if (profileData && profileData?.role === roles.adult && this.route.snapshot.paramMap.get('memberId')) {
        const filteredData = profileData.participants
          .filter(participant=>!(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))

        if(filteredData.length === 0){
          this.showDisclaimerBlock = true
        }
      }
      if (this.route.snapshot.paramMap.get('memberId')) {
        if (profileData && profileData.role === roles.participant && !profileData['groupId']) {
          this.showDisclaimerBlock = true
          return;
        }
      }
    })
  }

  ngOnInit() {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();

        if (JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
          this.commonService.urlParams.next(urlParams);
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
